module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal modal-special",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--lg"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [(!_vm.task_validated) ? [_vm._v("Crear Tarea")] : [_vm._v("Confirmar Tarea")], _vm._v(" "), _c('br'), _vm._v(" "), _c('AppTitleCustom')], 2)]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.name),
      expression: "task.name"
    }],
    class: ("input w-full border mt-2 flex-1 " + (_vm.task_validated && 'border-theme-12')),
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.task_validated
    },
    domProps: {
      "value": (_vm.task.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.description),
      expression: "task.description"
    }],
    staticClass: "input w-full border mt-2",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "rows": "3",
      "disabled": _vm.task_validated
    },
    domProps: {
      "value": (_vm.task.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Proporciona una descripción completa y clara de\n                lo que necesitas.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.date),
      expression: "task.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "type": "date",
      "required": "",
      "disabled": _vm.task_validated
    },
    domProps: {
      "value": (_vm.task.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.project_id),
      expression: "task.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": _vm.task_validated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ("create-task-project-" + (project.id)),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.campaign_id),
      expression: "task.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": _vm.task_validated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ("create-task-campaign-" + (campaign.id)),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + " - " + _vm._s(campaign.project.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    class: {
      'border-theme-12 border': _vm.task_validated
    },
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true,
      "disabled": _vm.task_validated
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.task.path),
      callback: function($$v) {
        _vm.$set(_vm.task, "path", $$v)
      },
      expression: "task.path"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Recuerda compartir la carpeta o archivo a las\n                personas involucradas.\n              ")])]), _vm._v(" "), (_vm.task_loading < 11 && 0 < _vm.task_loading) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('p', {
    staticClass: "text-theme-1 font-extrabold block"
  }, [_vm._v("\n                El botón se activara en " + _vm._s(_vm.task_loading) + " segundos, mientras\n                verificas la información.\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.task_validated),
      expression: "!task_validated"
    }],
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Verificar Tarea\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task_validated),
      expression: "task_validated"
    }],
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('a', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.task_validated = !_vm.task_validated
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "disabled": _vm.taskButtonLoading
    }
  }, [(_vm.taskButtonLoading) ? [_vm._v("\n                Verificando Tarea...\n              ")] : [_vm._v(" Confirmar Tarea ")]], 2)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d6a821","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/CreateTaskModal.vue
// module id = 423
// module chunks = 1